
import { Component, Prop, Vue } from 'nuxt-property-decorator'

@Component({})
export default class Error extends Vue {
  @Prop({ default: 500 }) readonly errorCode!: number
  @Prop({ default: true }) readonly hasImg!: boolean
  @Prop({ default: 'Indexer Error' }) errorTitle!: string
  @Prop({ default: 'Indexer is not working properly.' }) errorSubtitle!: string

  get imgSrc() {
    return `https://http.cat/${this.$props.errorCode}`
  }
}
